export default "__VITE_ASSET__CBWoXe3p__"